import React from 'react';
import PropTypes from 'prop-types';
import handleEvent from '../../../common/events/HandleEvent';
import CommonAppSetup from '../../../common/common-app-setup/CommonAppSetup';
import InputContainer from '../input-container/InputContainer';
import Components from '../../../common/Components';
import joinClassNames from "../../../common/JoinClassNames";

const propTypes = {
	// css classes to add to the wrapper
	className: PropTypes.string,

	// the name of the redux field being edited or a way to identify this link
	field: PropTypes.string,

	// where to go when the link is pressed (if onClick is not undefined)
	href: PropTypes.string,

	// the label/placeholder to show
	label: PropTypes.string.isRequired,

	// the text of the link in between the a's -- <a>Link Text</a>
	linkText: PropTypes.string.isRequired,

	// callback if clicked, otherwise goes to href link
	onClick: PropTypes.func,

	// should it have a target="_blank" in the <a>?
	openInTab: PropTypes.bool,

	// When the component mounts should the link should be given focus.
	setInitialFocus: PropTypes.bool,

	// should the label be shown?
	showLabel: PropTypes.bool,
};

const defaultProps = {
	className: undefined,
	field: undefined,
	href: '#',
	onClick: undefined,
	openInTab: false,
	setInitialFocus: false,
	showLabel: true,
};

export default class Link extends React.Component {
	constructor(props) {
		super(props);

		this.onClick = this.onClick.bind(this);
		this.linkRef = React.createRef();
	}

	componentDidMount() {
		if (this.props.setInitialFocus) {
			this.linkRef.current.focus();
		}
	}

	onClick(e) {
		this.props.onClick(this.props.field, e);
	}

	render() {
		return (
			<InputContainer className={joinClassNames(this.props.className, CommonAppSetup.getClassName(Components.LINK, 'wrapper'))}>
				<label
					className={joinClassNames(
						this.props.showLabel ? '' : 'visually-hidden',
						CommonAppSetup.getClassName(Components.LINK, 'label')
					)}
				>
					{this.props.label}
				</label>
				<a
					className={joinClassNames(
						"form-link",
						this.props.showLabel ? '' : 'no-label',
						CommonAppSetup.getClassName(Components.LINK, 'input')
					)}
					href={this.props.href}
					onClick={this.props.onClick ? handleEvent(this.onClick) : undefined}
					ref={this.linkRef}
					target={this.props.openInTab ? '_blank' : undefined}
				>
					{this.props.linkText}
				</a>
			</InputContainer>
		);
	}
}

Link.propTypes = propTypes;
Link.defaultProps = defaultProps;